<template>
  <div class="w-full mt-12">
    <h1 class="w-full mb-4 flex justify-center text-3xl text-ihh-midnight-gray font-ihh-bold">Custom Birth Kit Updates</h1>


    <Mango collection="blogs" v-slot="{ loading }" @update:data="blogs = $event" :query="{ limit: 100}">
        <Spinner v-if="loading" />
        <!-- Bogs Div -->
         <div v-else class="w-full mb-24 px-2 text-ihh-form-label text-base">
             <div v-for="(blog, index) in this.blogs" :key="index" class="w-full flex flex-col items-center justify-center pt-6 pb-10 border-b last:border-b-0 border-ihh-light-gray">
                <router-link :to="`/blogs/${blog.slug}`" class="text-xl mb-2 text-ihh-dark-salmon font-ihh-bold">{{ blog.title }}</router-link>
                <p class="text-sm">Posted by {{ blog.author }} on {{ formatDate(new Date(blog.dateCreated)) }}</p>
                <p class=" my-4 w-3/4 lg:max-w-4xl space-x-1">
                    <span>{{ blogPreview[index] }}...</span>
                    <router-link :to="`/blogs/${blog.slug}`" class="text-ihh-dark-salmon text-lg underline">read more</router-link>
                </p>
             </div>
         </div>
    </Mango>
  </div>
</template>

<script>
export default {
  name: "CustomBirthKitUpdates",
  data() {
    return {
        date: new Date().toISOString(),
        blogs: []
    };
  },
  methods: {
    formatDate(date) {
        const day = date.getDate();
        const month = date.toLocaleString('default', { month: 'short' });
        const year = date.getFullYear();

        const ordinalSuffix = (day) => {
            if (day > 3 && day < 21) return 'th';
            switch (day % 10) {
            case 1: return 'st';
            case 2: return 'nd';
            case 3: return 'rd';
            default: return 'th';
            }
        };

        return `${day}${ordinalSuffix(day)} ${month} ${year}`;
    },
  },
  computed: {
    formattedDate() {
      const date = new Date(this.date);
      const day = date.getDate();
      const month = date.toLocaleString('default', { month: 'short' });
      const year = date.getFullYear();

      const ordinalSuffix = (day) => {
        if (day > 3 && day < 21) return 'th';
        switch (day % 10) {
          case 1: return 'st';
          case 2: return 'nd';
          case 3: return 'rd';
          default: return 'th';
        }
      };

      return `${day}${ordinalSuffix(day)} ${month} ${year}`;
    },
    blogPreview() {
        return this.blogs.map(blog => {
        if (blog && blog.content) {
            const parser = new DOMParser();
            const doc = parser.parseFromString(blog.content, 'text/html');
            const textContent = doc.body.textContent || ''; // Extract plain text from HTML
            return textContent.substring(0, 150); // Return the first 50 characters
        }
        return ''; // Return an empty string if the structure or content is unavailable
        });
    }
  }
};
</script>

<style scoped>
</style>
